import React from 'react';
import { Wrap, BigLine, Track, Segment, Legend, LegendItem, Dot, SEGMENT_COLORS } from './BarStat.styled';

export interface BarStatProps {
  pendingCount: number;
  approvedCount: number;
  failedCount: number;
  totalCount: number;
  label: string;
  approvedLabel: string;
  pendingLabel: string;
  failedLabel: string;
}

export default function BarStat({
  pendingCount,
  approvedCount,
  failedCount,
  totalCount,
  label,
  approvedLabel,
  pendingLabel,
  failedLabel,
}: BarStatProps) {
  const pct = (count: number) => (totalCount > 0 ? (count / totalCount) * 100 : 0);

  return (
    <Wrap>
      <BigLine>
        <b>
          {pendingCount}/{totalCount}
        </b>
        <span>{label}</span>
      </BigLine>
      <Track>
        <Segment color={SEGMENT_COLORS.approved} pct={pct(approvedCount)} />
        <Segment color={SEGMENT_COLORS.failed} pct={pct(failedCount)} />
      </Track>
      <Legend>
        <LegendItem>
          <Dot color={SEGMENT_COLORS.approved} />
          {approvedLabel} <b>{approvedCount}</b>
        </LegendItem>
        <LegendItem>
          <Dot color={SEGMENT_COLORS.pending} />
          {pendingLabel} <b>{pendingCount}</b>
        </LegendItem>
        {failedCount > 0 && (
          <LegendItem>
            <Dot color={SEGMENT_COLORS.failed} />
            {failedLabel} <b>{failedCount}</b>
          </LegendItem>
        )}
      </Legend>
    </Wrap>
  );
}
